var link_preview_default = {
  "fontElementMap": "hYtTi",
  "linkPreviewContainer": "eS1-S",
  "linkPreview": "LMOge",
  "linkPreviewImage": "rTYNp",
  "linkPreviewPlaceholder": "jdDFH",
  "linkPreviewInfo": "Se2Sm",
  "linkPreviewTitle": "RU-dO",
  "linkPreviewDescription": "bmccw",
  "linkPreviewUrl": "XpFB7",
  "linkPreviewResponsiveImage": "hO6pY",
  "loadingContainer": "GJhmP",
  "errorIcon": "IhHju",
  "errorInfo": "xk3RI",
  "errorContainer": "QEo6L",
  "overlay": "cRcXR",
  "thumbnailEnd": "PQzb4",
  "thumbnailStart": "MhXhp",
  "thumbnailTop": "Azdkp"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
